import { useGetUsersQuery } from "@features/users/usersApi";
import LeaderboardItem from "./LeaderboardItem";

const LeaderboardList = ({ assignmentMarks = [], quizMarks = [] }) => {
  const { data: users } = useGetUsersQuery();

  // users array with total quiz mark set to 0
  const quizScores = users?.reduce((acc, curr) => {
    acc[curr.id] = {
      student_id: curr.id,
      student_name: curr.name,
      quizMark: 0,
    };
    return acc;
  }, {});

  // users array with total assignment mark set to 0
  const assignmentScores = users?.reduce((acc, curr) => {
    acc[curr.id] = {
      student_id: curr.id,
      assignmentMark: 0,
    };
    return acc;
  }, {});

  // Add the quiz scores to the corresponding user in the new object
  quizMarks?.forEach((quiz) => {
    quizScores[quiz.student_id].quizMark += quiz.mark;
  });

  // Add the assignment scores to the corresponding user in the new object
  assignmentMarks?.forEach((assignment) => {
    assignmentScores[assignment.student_id].assignmentMark += assignment.mark;
  });

  // merge quizScores and assignmentScores
  const mergedScores =
    quizScores &&
    Object.values(quizScores)?.map(
      ({ student_id, student_name, quizMark }) => ({
        student_id,
        student_name,
        quizMark,
        assignmentMark: assignmentScores[student_id].assignmentMark,
        totalMark: quizMark + assignmentScores[student_id].assignmentMark,
      })
    );

  // sort mergedScores in descending order based on totalMark
  mergedScores?.sort((a, b) => b.totalMark - a.totalMark);

  // calculate rank
  let rank = 1;
  let prevTotalMark = null;

  mergedScores?.forEach((score, index) => {
    if (score.totalMark !== prevTotalMark) {
      rank = index + 1;
      prevTotalMark = score.totalMark;
    }
    score.rank = rank;
  });

  return (
    <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
      <thead>
        <tr className="border-b border-slate-600/50">
          <th className="table-th !text-center">Rank</th>
          <th className="table-th !text-center">Name</th>
          <th className="table-th !text-center">Quiz Mark</th>
          <th className="table-th !text-center">Assignment Mark</th>
          <th className="table-th !text-center">Total</th>
        </tr>
      </thead>

      <tbody>
        {mergedScores?.length <= 20 &&
          mergedScores?.map((user) => (
            <LeaderboardItem key={user.student_id} user={user} />
          ))}
      </tbody>
    </table>
  );
};

export default LeaderboardList;
